import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { OptionsAltPage } from './pages/OptionsAltPage';
import { BuyersPage } from './pages/BuyersPage';
import { PDFSummariesPage } from './pages/PDFSummariesPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { SettingsPage } from './pages/SettingsPage';
import { SupportPage } from './pages/SupportPage';
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
import { BuildersPage } from './pages/admin/BuildersPage';
import { BuilderDetailPage } from './pages/admin/BuilderDetailPage';
import { AdminProjectsPage } from './pages/admin/AdminProjectsPage';
import { ProjectDetailPage } from './pages/admin/ProjectDetailPage';
import { UsersPage } from './pages/admin/UsersPage';
import { TelemetryPage } from './pages/admin/TelemetryPage';
import { SystemSettingsPage } from './pages/admin/SystemSettingsPage';
import { RequestsPage } from './pages/RequestsPage';
import { AdminRequestsPage } from './pages/admin/AdminRequestsPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Default redirect to Mattamy (for demo purposes) */}
        <Route index element={<Navigate to="/mattamy/dashboard" replace data-id="element-3" />} data-id="element-2" />

        {/* Builder Routes - with :builderId prefix */}
        <Route path="/:builderId" element={<Layout data-id="element-5" />} data-id="element-4">
          <Route index element={<Navigate to="dashboard" replace data-id="element-7" />} data-id="element-6" />
          <Route path="dashboard" element={<DashboardPage data-id="element-9" />} data-id="element-8" />
          <Route path="projects" element={<ProjectsPage data-id="element-11" />} data-id="element-10" />
          <Route path="options" element={<OptionsAltPage data-id="element-13" />} data-id="element-12" />
          <Route path="requests" element={<RequestsPage data-id="element-15" />} data-id="element-14" />
          <Route path="customers" element={<BuyersPage data-id="element-17" />} data-id="element-16" />
          <Route path="customers/:id" element={<CustomerDetailPage data-id="element-19" />} data-id="element-18" />
          <Route path="customers/summaries" element={<PDFSummariesPage data-id="element-21" />} data-id="element-20" />
          <Route path="analytics" element={<AnalyticsPage data-id="element-23" />} data-id="element-22" />
          <Route path="settings" element={<Navigate to="mortgage" replace data-id="element-25" />} data-id="element-24" />
          <Route path="settings/mortgage" element={<SettingsPage data-id="element-27" />} data-id="element-26" />
          <Route path="settings/general" element={<SettingsPage data-id="element-29" />} data-id="element-28" />
          <Route path="support" element={<SupportPage data-id="element-31" />} data-id="element-30" />
        </Route>

        {/* Admin Routes - no builder prefix */}
        <Route path="/admin" element={<Layout data-id="element-33" />} data-id="element-32">
          <Route index element={<Navigate to="dashboard" replace data-id="element-35" />} data-id="element-34" />
          <Route path="dashboard" element={<AdminDashboardPage data-id="element-37" />} data-id="element-36" />
          <Route path="builders" element={<BuildersPage data-id="element-39" />} data-id="element-38" />
          <Route path="builders/:builderId" element={<BuilderDetailPage data-id="element-41" />} data-id="element-40" />
          <Route path="projects" element={<AdminProjectsPage data-id="element-43" />} data-id="element-42" />
          <Route path="projects/:projectId" element={<ProjectDetailPage data-id="element-45" />} data-id="element-44" />
          <Route path="users" element={<UsersPage data-id="element-47" />} data-id="element-46" />
          <Route path="requests" element={<AdminRequestsPage data-id="element-49" />} data-id="element-48" />
          <Route path="telemetry" element={<TelemetryPage data-id="element-51" />} data-id="element-50" />
          <Route path="settings" element={<SystemSettingsPage data-id="element-53" />} data-id="element-52" />
        </Route>
      </Routes>
    </BrowserRouter>;
}